/* global modForm modUtils */
import { addHiddenVapiInput } from './addHiddenVapiInput';
import { preventRecaptchaFileLoad } from './preventRecaptchaFileLoad';
import { onRecaptchaLoad } from './onRecaptchaLoad';

/**
 * Initializes the reCAPTCHA widget and configures form fields for validation.
 * Skips reCAPTCHA setup for non-direct-traffic and non-default-quad scenarios.
 * @returns {void}
 */
export function initRecaptcha() {
	modForm.opts.recaptchaField = document.getElementById('recaptcha-field');
	modForm.opts.recaptchaContainer = document.getElementById('recaptcha-container');

	if (!modForm.opts.isDirectTraffic && !modForm.opts.usingDefaultQuad) {
		preventRecaptchaFileLoad();
		return;
	}

	if (!modForm.opts.recaptchaField) {
		return;
	}

	modForm.opts.validateRecaptcha = modUtils.getEnv() !== 'local';
	addHiddenVapiInput();
	modForm.opts.recaptchaField.dataset.required = 'nonempty';

	if (!modForm.opts.isRecaptchaScriptLoaded) {
		onRecaptchaLoad();
	}
}
